import _ from 'lodash';
import { 
    Box, 
    IconButton,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { UpdateRounded, ClearAllRounded } from '@mui/icons-material';
import RedirectsHistoryTopBarFilters from './RedirectsHistoryTopBarFilters';
import RedirectChartTopBarFilters from './RedirectChartTopBarFilters';
import RedirectsViewModeSelect from './RedirectsViewModeSelect';
import { redirectsViewModes, DefaultSettings } from '..';

const RedirectsTopBar = props => {

    const {
        reload,
        resetSettings,
        redirectsViewMode,
        settings,
        matchesRedirectsHistoryOnly,
        ...otherProps
    } = props;

    const theme = useTheme();
    const matchesDownMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Box    
            sx={{
                display: 'flex', 
                flexDirection: matchesDownMd ? 'column' : 'row', 
                gap: matchesDownMd && 1.5,
                mb: matchesDownMd && 2,
            }}
        >
            <Box sx={{display: 'flex', alignItems: 'center'}}>
                <RedirectsViewModeSelect 
                    redirectsViewMode={redirectsViewMode}
                    matchesRedirectsHistoryOnly={matchesRedirectsHistoryOnly}
                    {...otherProps}
                />
                <Box sx={{display: 'flex'}}>
                    <IconButton onClick={reload}>
                        <UpdateRounded/>
                    </IconButton>
                    {
                        !_.isEqual(settings, DefaultSettings) && redirectsViewMode === redirectsViewModes.history &&
                        <IconButton onClick={resetSettings}>
                            <ClearAllRounded/>
                        </IconButton>
                    }
                </Box>
            </Box>
            <Box sx={{marginLeft: !matchesDownMd && 'auto'}}>
                <RedirectsTopBarFilters
                    redirectsViewMode={redirectsViewMode}
                    settings={settings}
                    {...otherProps}
                />
            </Box>
        </Box>
    );
}

const RedirectsTopBarFilters = ({ redirectsViewMode, ...otherProps }) => {
    return (
        <>
            {
                redirectsViewMode === redirectsViewModes.history ?
                <RedirectsHistoryTopBarFilters {...otherProps} /> : 
                <RedirectChartTopBarFilters {...otherProps} />
            }
        </>
    );
}

export default RedirectsTopBar;